import { Injectable, inject } from '@angular/core';
import { App } from '@df/core/app';
import { TimeoutService } from '@df/ng/timeout.service';
import { RequestService } from '@df/api/request/request.service';
import { Subject } from 'rxjs';
import { GoogleMaps } from '@df/module-google-maps/google-maps.namespace';

@Injectable({ providedIn: 'root' })
export class GoogleMapsService {
    private loaded = false;

    private loadedSubject = new Subject<void>();

    private loading = false;

    private moduleConfig = inject(GoogleMaps.OPTIONS);

    constructor(
        private app: App,
        private timeoutService: TimeoutService,
        private requestService: RequestService
    ) {}

    load(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (this.loaded) {
                resolve();
            } else if (this.loading || this.isAvailable) {
                let timeoutId;

                const onReadySubscription = this.loadedSubject.subscribe(() => {
                    if (timeoutId) {
                        clearTimeout(timeoutId);
                    }
                    onReadySubscription.unsubscribe();
                    resolve();
                });

                timeoutId = this.timeoutService.setTimeout(() => {
                    onReadySubscription?.unsubscribe();
                    reject();
                }, 10000);

                if (!this.loading) {
                    this.loading = true;
                    const apiOptions = {
                        ...this.moduleConfig.apiOptions,
                        key: this.app.dfConfig.gmaps?.key || ''
                    };
                    window[apiOptions.callback] = () => this.onReady();
                    this.app.request.loadScript(GoogleMaps.API_JS_URL + '?' + this.app.request.serialize(<any>apiOptions), undefined);
                }
            } else {
                reject();
            }
        });
    }

    geocode(data: GoogleMaps.ILocateRequest): Promise<GoogleMaps.ILocateCallResponse[]> {
        return this.requestService.send(undefined, { path: '/locate', data }, undefined, undefined, { api: 'node', method: 'POST' });
    }

    private onReady(): void {
        this.loading = false;
        this.loaded = true;
        this.loadedSubject.next();
    }

    private get isAvailable(): boolean {
        return this.app.isPlatformBrowser && !this.app.client.isBot;
    }
}
